import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import LanOutlinedIcon from '@mui/icons-material/LanOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { Box, List, ListItemButton, ListItemText, Typography, styled } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { IStageStatusPair, getAllBusinessDefinition } from 'wisestep-api';
import { WsColors, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import {
  IBusinessData,
  stageStatusPipelineType,
} from '../../../../../features/crmSettings/customizeStageStatus/helper';
import { IAggregation } from '../../../../../features/submissions/hooks/useSubmissionListingStageStats';
import ErrorLogger from '../../../../../providers/ErrorLogger';
import {
  getStageStatusSettings,
  // getCandidateStageCategories,
  getCandidateStageData,
} from '../../../../../utils/CandidateStageStatusHelper';

interface TypoProps {
  textColor: string;
}
const TypographyTheme = styled(Typography)(({ textColor }: TypoProps) => ({
  color: textColor,
  fontSize: '18px',
  textAlign: 'right',
}));
const BoxNavTheme = styled(Box)(() => ({
  borderRadius: 4,
  maxWidth: 273,
  backgroundColor: WsColors.White,
}));

export interface WsSelectBusinessDefinitionNew {
  businessDefinitionName: string;
  createdBy?: string;
  createdOn?: string;
  id?: string;
  isArchive?: boolean;
  jobOption?: string;
  modifiedBy?: string;
  modifiedOn?: string;
  stageStatusData: IStageStatusPair[];
  workspaceId?: string;
}
interface submissionListSideNavProps {
  setSelectedStageStatus: (stage: string, status: string, count: number) => void;
  selectedIndexValue: (index: number, value: string) => void;
  stageStats?: IAggregation[];
  totalCandidateCount: number;
  isStageStatus: (value: boolean) => void;
  updateStageStatus: () => void;
  updateBusinessStageStatus: (data: string, count: number) => void;
  deleteBDFilterIndex?: boolean;
  deleteCSFilterIndex?: boolean;
  allStageStats?: IAggregation[];
  openStageStats?: IAggregation[];
  closeStageStats?: IAggregation[];
  allCandidatesCountForBD?: number;
}
const SubmissionListSideNav = ({
  setSelectedStageStatus,
  selectedIndexValue,
  stageStats,
  totalCandidateCount,
  isStageStatus,
  updateStageStatus,
  updateBusinessStageStatus,
  deleteBDFilterIndex = false,
  deleteCSFilterIndex = false,
  allStageStats,
  openStageStats,
  closeStageStats,
  allCandidatesCountForBD,
}: submissionListSideNavProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);
  const [selectedBDIndex, setSelectedBDIndex] = useState<number>(-1);
  const [selectedSubIndex, setSelectedSubIndex] = useState<number>(-1);
  const [selectedState, setSelectedState] = useState<string>();
  const [businessDefexpanded, setBusinessDefexpanded] = useState<boolean>();
  const [candidateExpanded, setCandidateExpanded] = useState<boolean>();
  const [candidateStatusExpanded, setCandidateStatusExpanded] = useState<number>(-1);
  const hoverTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // const [candidateStageStatusSettings, setCandidateStageStatusSettings] = useState<string>();
  const handleClickBusinessDef = (index: boolean) => setBusinessDefexpanded(index);

  const handleClickCandidate = (index: boolean) => setCandidateExpanded(index);

  const handleClickCandidateStatus = (index: number) =>
    index !== candidateStatusExpanded && setCandidateStatusExpanded(index);

  // const [stages, setStages] = useState<string[]>([]);
  const [stagesData, setStagesData] = useState<stageStatusPipelineType[]>([]);
  const [businessDefinitionData, setBusinessDefinitionData] = useState<IBusinessData[]>([]);

  const onChange = (index: number, value: string | number) => {
    selectedIndexValue(index, String(value));
    setSelectedSubIndex(-1);
    setSelectedIndex(index);
    isStageStatus(false);
  };

  const onSelectState = (
    subValue: string,
    subIndex: number,
    value: string | number,
    index: number,
    count: number
  ) => {
    setSelectedSubIndex(subIndex);
    setSelectedState(subValue);
    setSelectedIndex(index);
    setSelectedStageStatus(String(value), subValue, count);
  };

  const backArrowClick = () => {
    setSelectedIndex(-1);
    isStageStatus(false);
    updateStageStatus();
  };

  const clearBusinessDefClick = () => {
    setSelectedBDIndex(-1);
    isStageStatus(false);
    updateStageStatus();
  };
  useEffect(() => {
    setSelectedBDIndex(-1);
  }, [deleteBDFilterIndex]);

  useEffect(() => {
    setSelectedIndex(-1);
    setSelectedSubIndex(-1);
  }, [deleteCSFilterIndex]);

  useEffect(() => {
    const getStages = async () => {
      const response = await getStageStatusSettings();
      // setCandidateStageStatusSettings(response?.data.stageStatusPipeline);
      // setStages(getCandidateStageCategories(response?.data));
      setStagesData(getCandidateStageData(response?.data));
    };
    getStages();
  }, []);

  useEffect(() => {
    const getStages = async () => {
      const response = await getAllBusinessDefinition();

      setBusinessDefinitionData(response?.data);
      if (response?.data.length > 0) {
        setBusinessDefexpanded(true);
        setCandidateExpanded(false);
      } else {
        setBusinessDefexpanded(false);
        setCandidateExpanded(true);
      }
    };
    getStages();
  }, []);

  const businessFilterClick = (element, index, count) => {
    const optionObject: WsSelectBusinessDefinitionNew = {
      businessDefinitionName: element.businessDefinitionName,
      jobOption: element.jobOption,
      stageStatusData: element.stageStatusData.flatMap((ssd) =>
        ssd.selectedStatuses.map((ss) => ({
          applicationStage: ssd.stage,
          applicationState: ss,
        }))
      ),
    };
    setSelectedBDIndex(index);

    optionObject && updateBusinessStageStatus(JSON.stringify(optionObject), count);
  };

  const getCount = (element) => {
    const currentStatus =
      element.jobOption === 'open_jobs'
        ? openStageStats
        : element.jobOption === 'closed_jobs'
        ? closeStageStats
        : allStageStats;
    let count = 0;
    element.stageStatusData.forEach((ss) => {
      currentStatus?.forEach((ssKey) => {
        if (ssKey.key === ss.stage) {
          ss.selectedStatuses.forEach((ssStageSelectedStatuses) => {
            ssKey.aggregation?.buckets.forEach((ssKeyBucket) => {
              if (ssKeyBucket.key === ssStageSelectedStatuses) {
                count = count + parseInt(ssKeyBucket.doc_count, 10);
              }
            });
          });
        }
      });
    });
    return count;
  };

  // const getSubStatusesOfStatus = (stage: string) => {
  //   let subStatusArray: string[] = [];
  //   if (candidateStageStatusSettings)
  //     JSON.parse(candidateStageStatusSettings).map((object) => {
  //       if (object.stage == stage && object.statuses?.length > 0) {
  //         object.statuses.forEach((subStatus) => {
  //           subStatusArray = [...subStatusArray, subStatus.value];
  //         });
  //       }
  //     });
  //   return subStatusArray;
  // };

  const getStageObject = (stage: string) =>
    stageStats?.find((stageStat) => stageStat.key === stage);

  const getStateObject = (stage: string, state: string) => {
    const a = getStageObject(stage);
    return a?.aggregation?.buckets?.find((test) => test.key == state);
  };

  const handleMouseOver = (index: number) => {
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    hoverTimeoutRef.current = setTimeout(() => {
      handleClickCandidateStatus(index);
    }, 300);
  };

  return (
    <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
      <BoxNavTheme className="index-filters">
        {businessDefinitionData.length > 0 && (
          <List component="nav">
            <ListItemButton
              sx={{
                background: WsColors.White,
              }}
              key={0}
              onClick={() => {
                handleClickBusinessDef(!businessDefexpanded);
              }}
            >
              <ListItemText
                primary={
                  <WsTypography
                    variant={WsTypoVariants.SUB_TITLE}
                    color={businessDefexpanded ? WsTypoColors.PRIMARY : WsTypoColors.SECONDARY}
                    cursor="pointer"
                  >
                    <LanOutlinedIcon fontSize="small" dy={10} viewBox="0 -10 30 30" />
                    Business Definition
                  </WsTypography>
                }
              />

              {businessDefexpanded ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            {businessDefexpanded &&
              businessDefinitionData.map((element, index) => (
                <>
                  {index == 0 && (
                    <ListItemButton
                      sx={{
                        background: selectedBDIndex === -1 ? WsColors.TheBlues100 : WsColors.White,
                      }}
                      onClick={clearBusinessDefClick}
                    >
                      <ListItemText
                        primary={
                          <WsTypography
                            variant={WsTypoVariants.BODY1}
                            color={WsTypoColors.BLACK}
                            cursor="pointer"
                          >
                            All
                          </WsTypography>
                        }
                      />
                      <TypographyTheme textColor={WsColors.GenericRichBlack}>
                        {allCandidatesCountForBD}
                      </TypographyTheme>
                    </ListItemButton>
                  )}
                  <ListItemButton
                    key={index}
                    sx={{
                      background: index === selectedBDIndex ? WsColors.TheBlues100 : WsColors.White,
                    }}
                    onClick={() => businessFilterClick(element, index, getCount(element))}
                  >
                    <ListItemText
                      primary={
                        <WsTypography
                          variant={WsTypoVariants.BODY1}
                          color={WsTypoColors.BLACK}
                          cursor="pointer"
                        >
                          {element.businessDefinitionName}
                        </WsTypography>
                      }
                    />
                    <TypographyTheme textColor={WsColors.GenericRichBlack}>
                      {getCount(element)}
                    </TypographyTheme>
                  </ListItemButton>
                </>
              ))}
          </List>
        )}
        <List component="nav">
          <ListItemButton
            sx={{
              background: WsColors.White,
            }}
            key={0}
            onClick={() => handleClickCandidate(!candidateExpanded)}
          >
            <ListItemText
              primary={
                <WsTypography
                  variant={WsTypoVariants.SUB_TITLE}
                  color={candidateExpanded ? WsTypoColors.PRIMARY : WsTypoColors.SECONDARY}
                  cursor="pointer"
                >
                  <PeopleAltOutlinedIcon fontSize="small" viewBox="0 -10 30 30" />
                  Candidate Status
                </WsTypography>
              }
            />

            {candidateExpanded ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          {candidateExpanded &&
            stagesData?.map((stage, index) => (
              <>
                {index == 0 && (
                  <ListItemButton
                    sx={{
                      background: selectedIndex === -1 ? WsColors.TheBlues100 : WsColors.White,
                    }}
                    onClick={() => backArrowClick()}
                  >
                    <ListItemText
                      primary={
                        <WsTypography
                          variant={WsTypoVariants.BODY1}
                          color={WsTypoColors.BLACK}
                          cursor="pointer"
                        >
                          All
                        </WsTypography>
                      }
                    />
                    <TypographyTheme textColor={WsColors.GenericRichBlack}>
                      {totalCandidateCount}
                    </TypographyTheme>
                  </ListItemButton>
                )}
                <ListItemButton
                  sx={{
                    background:
                      index === selectedIndex
                        ? WsColors.TheBlues100
                        : stage.isArchive
                        ? WsColors.BorderGrey
                        : WsColors.White,
                  }}
                  key={index}
                  onClick={() => {
                    onChange(index, stage.stage);
                    handleClickCandidateStatus(index);
                  }}
                  onMouseOver={() => handleMouseOver(index)}
                >
                  <ListItemText
                    primary={
                      <WsTypography
                        variant={WsTypoVariants.BODY1}
                        color={stage.isArchive ? WsTypoColors.GREYTEXT : WsTypoColors.BLACK}
                        cursor="pointer"
                      >
                        {stage.stage} {stage.isArchive && '(Archived)'}
                      </WsTypography>
                    }
                  />
                  <TypographyTheme textColor={WsColors.GenericRichBlack}>
                    {getStageObject(stage.stage)?.doc_count ?? 0}
                  </TypographyTheme>
                  {candidateStatusExpanded == index ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                {candidateStatusExpanded == index &&
                  stage.statuses.map((subStage, subIndex) => (
                    <ListItemButton
                      key={subIndex}
                      sx={{
                        py: 0,
                        minHeight: 32,
                        background:
                          subStage.value === selectedState && subIndex === selectedSubIndex
                            ? WsColors.TheBlues100
                            : subStage.isArchive
                            ? WsColors.BorderGrey
                            : WsColors.White,
                      }}
                      onClick={() =>
                        onSelectState(
                          subStage.value,
                          subIndex,
                          stage.stage,
                          index,
                          parseInt(getStateObject(stage.stage, subStage.value)?.doc_count ?? '0')
                        )
                      }
                    >
                      <ListItemText
                        primary={`${subStage.value} ${subStage.isArchive ? '(Archived)' : ''}`}
                        primaryTypographyProps={{ fontSize: 14, fontWeight: 'medium', pl: 4 }}
                      />
                      <TypographyTheme textColor={WsColors.GenericRichBlack}>
                        {getStateObject(stage.stage, subStage.value)?.doc_count ?? 0}
                      </TypographyTheme>
                    </ListItemButton>
                  ))}
              </>
            ))}
        </List>
      </BoxNavTheme>
    </ErrorBoundary>
  );
};
export default SubmissionListSideNav;
